import { call, put, takeEvery, all } from "redux-saga/effects";
import { CREATE_PUBLIC_MANUAL_PAYMENT_INTENT } from "./actionType";
import {
  createPublicManualPaymentIntentSuccess,
  createPublicManualPaymentIntentFailure,
} from "./action";
import { createPublicManualPaymentIntentApi } from "../../helpers/fakebackend_helper";

function* createPublicManualPaymentIntent({ payload }) {
  try {
    const response = yield call(createPublicManualPaymentIntentApi, payload);
    yield put(createPublicManualPaymentIntentSuccess(response));
  } catch (error) {
    yield put(createPublicManualPaymentIntentFailure(error));
  }
}

function* watchCreatePublicManualPaymentIntent() {
  yield takeEvery(
    CREATE_PUBLIC_MANUAL_PAYMENT_INTENT,
    createPublicManualPaymentIntent
  );
}

export default function* PublicManualPayment() {
  yield all([watchCreatePublicManualPaymentIntent()]);
}
